import slideshowComponent from 'components/slideshowComponent';
import pageDataObject from 'application/pageDataObject';

let routes = pageDataObject.isSlideshow ? {
  '/posts/:postId': slideshowComponent,
  '/posts/:postId/:slideId': slideshowComponent,
  '/:locale/posts/:postId': slideshowComponent,
  '/:locale/posts/:postId/:slideId': slideshowComponent,

  '/embed/posts/:postId': slideshowComponent,
  '/embed/posts/:postId/:slideId': slideshowComponent,
  '/hybrid/posts/:postId': slideshowComponent,
  '/hybrid/posts/:postId/:slideId': slideshowComponent,

  '/:locale/embed/posts/:postId': slideshowComponent,
  '/:locale/embed/posts/:postId/:slideId': slideshowComponent,

  '/:locale/hybrid/posts/:postId': slideshowComponent,
  '/:locale/hybrid/posts/:postId/:slideId': slideshowComponent,

  '/preview/:postId': slideshowComponent,
  '/preview/:postId/:slideId': slideshowComponent,
  '/:locale/preview/:postId': slideshowComponent,
  '/:locale/preview/:postId/:slideId': slideshowComponent,
} : {};

export default routes;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/routes/slideshowRoutes.js